export default __webpack_public_path__ + "static/media/drink.fa11ec00.png";